import React from "react";
import { Modal, Segment, Header, Button, Form, Grid } from "semantic-ui-react";
import { reduxForm, Field } from "redux-form";

class ModalFiltros extends React.Component {
  handleCancelarModal = () => {
    this.props.reset();
    this.props.handleCancelarModal();
  };

  handleEliminarFiltros = () => {
    this.props.reset();
    this.props.handleEliminarFiltros();
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Modal open={this.props.open} size="mini">
        <Modal.Header>
          <Header color="pink" content="Filtros por Edad" textAlign="center" />
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <Form>
              <Grid centered columns={2}>
                <Field
                  name="desde"
                  type="number"
                  min="3"
                  max="12"
                  label="Desde"
                  component={Form.Input}
                />
                <Field
                  name="hasta"
                  type="number"
                  min="3"
                  max="12"
                  label="Hasta"
                  component={Form.Input}
                />
              </Grid>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Header
            as="h4"
            textAlign="center"
            content="¿Qué hacemos con los filtros?"
          />
          <Segment basic>
            <Grid centered columns={3}>
              <Button
                inverted
                color="pink"
                icon="eraser"
                content="Quítalos"
                onClick={this.handleEliminarFiltros}
              />
              <Button
                inverted
                color="red"
                icon="cancel"
                content="Nada"
                onClick={this.handleCancelarModal}
              />
              <Button
                inverted
                color="green"
                icon="check"
                content="Aplícalos"
                onClick={handleSubmit(values =>
                  this.props.handleAplicarFiltros(values)
                )}
              />
            </Grid>
          </Segment>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default reduxForm({ form: "FormModalFiltros" })(ModalFiltros);



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/listaInscripciones/ModalFiltros.jsx